import { combineReducers } from "redux";
import { interactiveMapReducer } from "./1-modules/interactiveMapPage/ducks";

export default combineReducers({
  interactiveMap: interactiveMapReducer
});


